/**
 *
 * @template
 */
 import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { CommonService, UserInfoService , CartService } from 'abs-ngx-library/src/lib/core';
import { EnviormentConfig } from 'abs-ngx-library/src/lib/core';
import { IConfigObj} from 'abs-ngx-library/src/lib/core';
import { GenericGridDataObj, ProductGenericGridALV1Service } from 'abs-ngx-library/src/lib/product-generic-grid';

// jQuery
declare let $: any;

@Component({
  selector: 'offer-qualified-products-al-v1',
  templateUrl: './offer-qualified-products-al-v1.component.html',
})

export class OfferQualifiedProductsALV1Component implements OnInit {
  @ViewChild('qualifiedProductsContainer', { read: ViewContainerRef, static: true }) qualifiedProductsContainer: ViewContainerRef;
  @ViewChild('productGridTemplate', { read: TemplateRef, static: true }) productGridTemplate: TemplateRef<any>;

  @Input() dataValue;
  @Input() staticProducts;
  @Input() configObj: IConfigObj;
  @Input()
  public offer: any = {};
  @Input()
  public isBXGYEligibleOffer: boolean = false;

  public config = EnviormentConfig;

  public ack: boolean = true;
  public showGrid: boolean;
  public productGridPage;
  public objGridData: GenericGridDataObj = {
      drivenType: '',
      apiUrl: '',
      apiType: '',
      sorts: '',
      defaultSort: '',
      value: {},
      products : [],
      widgetId: '',
      load_type:'',
      infinite_type:'',
      doGenericFlow: false,
      modelConfigurationId: ''
  };
  public triggerBy = '';

  // Products that are passed to the product-generic-grid component
  public qualifiedProductsResponse : any;
  public JSONqualifiedProductsResponse : any;
  public eligibleJSONqualifiedProductsResponse : any = [];
  public currentEnv: string;
  public upcList: any = [];
  public eligibleUpcList: any = [];
  public isEligibleUpcListTabSelected: boolean = false;
  public offers: any;

  public constructor(
      private _productGridService: ProductGenericGridALV1Service,
      public elementRef: ElementRef,
      public _commonService: CommonService,
      private _userInfoService: UserInfoService,
      private _cartService : CartService
  ) {

      const currentComponent = this.elementRef.nativeElement;
      const attributes = currentComponent && currentComponent.attributes;

      this.productGridPage = attributes['data-driven'] ? attributes['data-driven'].value : "catalog";
      const defaultSort = attributes['data-default-sorts'] ? attributes['data-default-sorts'].value : undefined;
      const dataApiType = attributes['data-api-type']?attributes['data-api-type'].value:'c-products-by-upc-drawer'
      this.objGridData = {
          drivenType: dataApiType=='s-bogo'?'static':this.productGridPage,
          apiUrl: attributes['data-api-url'] && attributes['data-api-url'].value,
          apiType: dataApiType,
          sorts: attributes['data-sorts'] && attributes['data-sorts'].value,
          defaultSort,
          value: {},
          products : [],
          widgetId: attributes['data-widget-id'] && attributes['data-widget-id'].value,
          load_type:attributes['data-load-type']? attributes['data-load-type'].value: 'loadmore',
          infinite_type:attributes['data-infinite-scroll-type']? attributes['data-infinite-scroll-type'].value: 'client',
          doGenericFlow: attributes['data-dogeneric-flow']? attributes['data-dogeneric-flow'].value == "true": false,
          badgePreference: attributes['data-badge-preferrence'] ? attributes['data-badge-preferrence'].value :'',
          badgeList: attributes['data-badge-list'] ? attributes['data-badge-list']?.value : ''
      };

      if (this.objGridData.doGenericFlow && this.objGridData.drivenType == 'generic') {
          this.objGridData.modelConfigurationId = this.getModelConfigIdFromUrl();
          const genericTitleElement = document.getElementById('genericGridTitle');
          const genericTitleText = new URLSearchParams(window.location.search).get('title')
          if (genericTitleElement && genericTitleText) {
              genericTitleElement.innerHTML = genericTitleText;
          }
      }

      this.triggerBy = this.productGridPage;
      if (this.productGridPage === 'purchase' || this.productGridPage === 'catalog' || this.productGridPage === 'static') {
          this.triggerBy =  this.objGridData.apiType;
      }

      try {
        let strValue = this.dataValue;
        if (this.dataValue === undefined) {
            strValue = this.elementRef.nativeElement.getAttribute('data-value');
        }
        strValue = strValue.replace(/'/g, '"');
        this.objGridData.value = JSON.parse(strValue);

    } catch (e) {
        // silent. objGridData.value has default value
    }

    if (this.objGridData.apiType === 'c-products-by-upc-drawer' ) {          
        this.setProductByUpcApiUrl();
    }

    if (this.productGridPage === 'static') {
        this.objGridData.products = this.staticProducts;
    }
    this.showGrid = false;

  }


  ngOnInit(): void {
        if (!this.configObj){
          this.configObj = {
            programType : 'abs'
          }
        }
        if (this.configObj && this.configObj.appName == 'b4u-offerDetails') {
          this.setProductByUpcApiUrl()
        }
        try {
          let strValue = this.dataValue;
          if (this.dataValue === undefined) {
              strValue = this.elementRef.nativeElement.getAttribute('data-value');
          }
          strValue = strValue.replace(/'/g, '"');
          this.objGridData.value = JSON.parse(strValue);

      } catch (e) {
          // silent. objGridData.value has default value
      }
      

    this._commonService._userInfoRefresh.subscribe(data => {
      if (data === 'initFunc'){
        if (this.configObj && this.configObj.bannerDomain) {
          this.objGridData.apiUrl = this.configObj.bannerDomain + this.objGridData.apiUrl;
        }

        this._productGridService.objGridData = this.objGridData;

        // assign products info to objGridData for static data
        if (this.productGridPage === 'static'){
            this.objGridData.products = this.staticProducts;
        }
        // get products to populate in product grid
        this.getProduct();
        this.setProgramTypeFromBannerTypeMetaTag();
        this._cartService.rightDrawerEvent.next({
          'event' : 'openOfferDetails',
          'data' : []
        });
      }
    })

      this._commonService.$bxgyOffer.subscribe(offer => {
          this.upcList = offer?.upcList || [];
          this.eligibleUpcList = offer?.eligibleUpcList || [];
      });

  }

  private setProductByUpcApiUrl() {
    this.currentEnv = this._commonService.getCurrentEnviorment();
    const catalogConfig = this.config[this.currentEnv].catalogConfig;

    this.objGridData.apiUrl = catalogConfig["apim.api.catalog.path"] + catalogConfig["apim.api.catalog.product.upc.endpoint"];
  }

  public getProduct() {
      this._productGridService.getData().subscribe((data: any) => {
          if (this.productGridPage !== 'static' && this.objGridData.drivenType !== 'generic'){
              data.products = this.configObj && this.configObj.appName && this.configObj.appName === 'weeklyAd' && data['response'] && data['response']['docs'] && data['response']['docs'].length > 0
                  ? data['response']['docs'].filter(pdt => !pdt.isMtoProduct)
                  : data['response']['docs'];
          }
          data.ack = false;
          this.offers = data?.['response']?.['offersData'] ?? data?.['offersData'] ?? {};
          this.qualifiedProductsResponse = data;

          if(this.isEligibleUpcListTabSelected) {
              this.eligibleJSONqualifiedProductsResponse = this.getQualifiedProductsJson(this.qualifiedProductsResponse);
          }
          else {
              this.JSONqualifiedProductsResponse = this.getQualifiedProductsJson(this.qualifiedProductsResponse);
          }
          this.showGrid = true;
      }, (err) => {
          //
      });
  }

  public getQualifiedProductsJson(productsData) {
    let jsonProducts = '{}';

    if (productsData && productsData.products) {
      jsonProducts = JSON.stringify(productsData);
    }

    return jsonProducts;
  }
  /**
  * Set programType value from BannerType Meta tag Content
  */
  private setProgramTypeFromBannerTypeMetaTag(){
    const isB2BSite = this._userInfoService?.getSiteType() === "B";
    if(isB2BSite){
        const bannerTypeContent =  $("meta[name='bannerType']").attr("content");
        this.configObj.programType = bannerTypeContent;
    }
  }

  private getModelConfigIdFromUrl(): string {
    try {
      return window.location.pathname.substring(1,).split('/')[2]
    } catch(e) {
      return ''
    }
  }

   /**
   *
   * Set the selected tab for BXGY offer and call the API to get the eligible products only first time
   */
   public handleTab(isEligibleUpcList: boolean, event: Event) {
    event.preventDefault();
    this.isEligibleUpcListTabSelected = isEligibleUpcList;
    if(isEligibleUpcList && !this.eligibleJSONqualifiedProductsResponse.length) {
        this.getProduct();
        this._commonService.upcs.next(this.eligibleUpcList);
     }
   }
}
